<div class="eb-favorites-item-header__select-all">
  <input
    type="checkbox"
    (change)="onItemSelectChange($event.target.checked)"
    [checked]="isAllSelected"
  />
</div>
<h5 class="col-6">
  {{ 'cartItems.description' | cxTranslate }}
</h5>
<div class="eb-favorites-item-header__checkbox-padding col-5">
  <div class="row">
    <h5 class="col-5">
      {{ 'cartItems.unit' | cxTranslate }}
    </h5>
    <h5 class="col-6 text-right" *ngIf="showPrice">
      {{ 'cartItems.itemPrice' | cxTranslate }}
    </h5>
    <h5 class="col-4" *ngIf="!hideQuantity">
      {{ 'cartItems.quantity' | cxTranslate }}
    </h5>
    <h5 class="col-3 text-right" *ngIf="showPrice && !hideQuantity">
      {{ 'cartItems.total' | cxTranslate }}
    </h5>
  </div>
</div>
